/* eslint-disable */
export default {
  activeCall: '進行中的通話',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
